import React from 'react';

export const LoadingLayout: React.FC<{
    isLoading: boolean;
    loadingComponent: React.ReactNode;
    isNoResults: boolean;
    noResultsComponent: React.ReactNode;
    resultComponent: React.ReactNode;
}> = ({ isLoading, loadingComponent, isNoResults, noResultsComponent, resultComponent }) => {
    if (isNoResults && isLoading) {
        return loadingComponent;
    }

    if (isNoResults) {
        return noResultsComponent;
    }

    return resultComponent;
};
